var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47717 20 0 15.5228 0 10C0 4.47717 4.47717 0 10 0C15.5228 0 20 4.47717 20 10ZM9.51318 6.19556V15C9.51318 15.2761 9.737 15.5 10.0132 15.5C10.2893 15.5 10.5132 15.2761 10.5132 15V6.22192L13.6461 9.36108C13.8412 9.55652 14.1578 9.55688 14.3532 9.36182C14.5486 9.16675 14.549 8.8501 14.3539 8.65466L10.4159 4.70898C10.3592 4.63208 10.2809 4.57202 10.19 4.5376C10.1302 4.51294 10.0659 4.5 10 4.5C9.86725 4.5 9.73987 4.55286 9.64612 4.64685L5.64612 8.65466C5.45105 8.8501 5.45135 9.16675 5.64679 9.36182C5.84222 9.55688 6.15881 9.55652 6.35388 9.36108L9.51318 6.19556Z",
    fill: "#1B1B1B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;